/* scroll-frames.js — scroll-scrubbed frame sequence for Shopify sections.
   Multi-instance and theme-editor safe. No UI of its own. */
(function () {
  "use strict";

  var instances = {};

  function Film(root) {
    var cfgEl = root.querySelector("[data-sf-config]");
    if (!cfgEl) return;
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    this.frames = this.cfg.frames || [];
    this.N = this.frames.length;
    if (!this.N) return;

    this.root = root;
    this.canvas = root.querySelector("[data-sf-canvas]");
    if (!this.canvas) return;
    this.ctx = this.canvas.getContext("2d", { alpha: false });
    this.ground = (getComputedStyle(root).getPropertyValue("--sf-ground") || "#FFFFFF").trim();

    this.reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.imgs = new Array(this.N);
    this.ready = new Array(this.N);
    this.loaded = 0; this.next = 0;
    this.lastDrawn = -1; this.curr = 0; this.target = 0;
    this.running = false; this.destroyed = false; this.raf = null;

    var self = this;
    this.onScroll = function () { self.schedule(); };
    this.onResize = function () { self.resize(); self.schedule(); };
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize);

    this.resize();
    this.pump();
  }

  Film.prototype.destroy = function () {
    this.destroyed = true;
    if (this.raf) cancelAnimationFrame(this.raf);
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
    for (var i = 0; i < this.N; i++) {
      if (this.imgs[i]) { this.imgs[i].onload = this.imgs[i].onerror = null; this.imgs[i] = null; }
    }
  };

  Film.prototype.resize = function () {
    var pin = this.canvas.parentElement;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.cw = pin.clientWidth; this.ch = pin.clientHeight;
    if (!this.cw || !this.ch) return;
    this.canvas.width = Math.round(this.cw * dpr);
    this.canvas.height = Math.round(this.ch * dpr);
    this.canvas.style.width = this.cw + "px";
    this.canvas.style.height = this.ch + "px";
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.lastDrawn = -1;
    this.draw(this.curr);
  };

  /* Letterbox rather than crop on wide screens — the bars are the same colour
     as the footage's background, so the seam is invisible. Narrow screens crop
     toward cover, capped, so the subject never shrinks to a stamp. */
  Film.prototype.fit = function (img) {
    var iw = img.naturalWidth || 1, ih = img.naturalHeight || 1;
    var contain = Math.min(this.cw / iw, this.ch / ih);
    var cover = Math.max(this.cw / iw, this.ch / ih);
    var k = (this.cfg.cropCap || 1.0);
    var s = Math.min(cover, contain * k);
    var w = iw * s, h = ih * s;
    return [(this.cw - w) / 2, (this.ch - h) / 2, w, h];
  };

  Film.prototype.draw = function (idx) {
    if (!this.cw || !this.ch) return;
    var i = Math.max(0, Math.min(this.N - 1, Math.round(idx)));
    if (!this.ready[i]) {
      var found = -1;
      for (var k = 1; k < this.N; k++) {
        if (this.ready[i - k]) { found = i - k; break; }
        if (this.ready[i + k]) { found = i + k; break; }
      }
      if (found < 0) return;
      i = found;
    }
    if (i === this.lastDrawn) return;
    this.lastDrawn = i;
    this.ctx.fillStyle = this.ground;
    this.ctx.fillRect(0, 0, this.cw, this.ch);
    var b = this.fit(this.imgs[i]);
    this.ctx.drawImage(this.imgs[i], b[0], b[1], b[2], b[3]);
  };

  Film.prototype.progress = function () {
    var travel = this.root.offsetHeight - window.innerHeight;
    if (travel <= 0) return 0;
    return Math.max(0, Math.min(1, -this.root.getBoundingClientRect().top / travel));
  };

  Film.prototype.tick = function () {
    if (this.destroyed) return;
    var d = this.target - this.curr;
    if (this.reduce || Math.abs(d) < 0.4) this.curr = this.target;
    else this.curr += d * 0.3;
    this.draw(this.curr);
    if (Math.abs(this.target - this.curr) > 0.05) {
      var self = this;
      this.raf = requestAnimationFrame(function () { self.tick(); });
    } else this.running = false;
  };

  Film.prototype.schedule = function () {
    if (this.destroyed) return;
    this.target = this.progress() * (this.N - 1);
    if (!this.running) {
      this.running = true;
      var self = this;
      this.raf = requestAnimationFrame(function () { self.tick(); });
    }
  };

  Film.prototype.pump = function () {
    while (this.next < this.N && this.next < this.loaded + 12) {
      this.load(this.next); this.next++;
    }
  };

  Film.prototype.load = function (i) {
    var self = this;
    var im = new Image();
    im.decoding = "async";
    im.onload = function () {
      self.ready[i] = true;
      if (i === 0) { self.lastDrawn = -1; self.draw(0); }
      self.loaded++;
      if (self.loaded === self.N) self.root.classList.add("sf-ready");
      self.pump();
    };
    im.onerror = function () { self.loaded++; self.pump(); };
    im.src = this.frames[i];
    this.imgs[i] = im;
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll("[data-scroll-frames]");
    for (var i = 0; i < roots.length; i++) {
      var el = roots[i], id = el.getAttribute("data-scroll-frames");
      if (instances[id]) continue;
      instances[id] = new Film(el);
    }
  }
  function teardown(id) {
    if (instances[id]) { instances[id].destroy(); delete instances[id]; }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(); });
  } else init();

  document.addEventListener("shopify:section:load", function (e) {
    teardown(e.detail.sectionId); init(e.target);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    teardown(e.detail.sectionId);
  });
})();
